import { inject, Injectable } from '@angular/core';
import { CompanyApiService } from './api/firms-api.service';
import { DBService } from './db.service';
import { FileService } from './file.service';
import { appDb } from 'dexie/app.db';
import { liveQuery } from 'dexie';
import { catchError, from, map, switchMap, throwError } from 'rxjs';
import { ErrorTypesApiService } from './api/error-types-api.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorTypesService {
  protected dbService = inject(DBService);
  protected fileService = inject(FileService);
  protected errorTypesApiService = inject(ErrorTypesApiService);

  getList(filter?: any) {
    let dbQuery = appDb.errorType.where('isDeleted').equals(0);
    if (filter?.name) {
      dbQuery = dbQuery.and((item) =>
        item.name.toLowerCase().startsWith(filter.name.toLowerCase())
      );
    }
    if (filter?.type) {
      dbQuery = dbQuery.and((item) => item.type === filter.type);
    }
    return from(liveQuery(() => dbQuery.sortBy('order')));
  }

  get(id: string) {
    return from(liveQuery(() => appDb.errorType.where('id').equals(id).first()));
  }

  getByIds(ids: Array<string>) {
    return from(
      liveQuery(() => appDb.errorType.where('id').anyOf(ids).toArray())
    );
  }

  create(data) {
    return this.errorTypesApiService.create(data).pipe(
      catchError((err: HttpErrorResponse) => {
        if (!navigator.onLine) {
          return this.dbService.createRow(appDb.errorType, {
            ...data,
            isSynced: 0,
            isDeleted: 0,
          });
        }
        return throwError(() => err);
      })
    );
  }

  update(id, data) {
    return this.errorTypesApiService
      .update(id, { id, name: data.name, order: data.order, type: data.type })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (!navigator.onLine) {
            return this.dbService.updateRow(appDb.errorType, {
              ...data,
              isSynced: 0,
              isDeleted: 0,
            });
          }
          return throwError(() => err);
        })
      );
  }

  delete(id: string) {
    return this.errorTypesApiService.delete(id).pipe(
      switchMap((res: any) => this.dbService.deleteRow(appDb.errorType, id)),
      catchError((err: HttpErrorResponse) => {
        if (!navigator.onLine) {
          return this.dbService.updateRow(appDb.errorType, {
            id,
            isDeleted: 1,
            isSynced: 0,
          });
        }
        return throwError(err);
      })
    );
  }

  getNotSyncedItems() {
    return from(appDb.errorType.where('isSynced').equals(0).toArray());
  }

  getNotSyncedItemsCount() {
    return from(
      liveQuery(() => appDb.errorType.where('isSynced').equals(0).count())
    );
  }
  bulkUpdateLocal(items) {
    return from(appDb.errorType.bulkPut(items));
  }
}
